
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function OrganisationTree(props) {

  const { organisations, currentId } = props;

  const [orgList, setOrgList] = useState(organisations);
  const [orgTree, setOrgTree] = useState();

  useEffect(() => {
    if(props.organisations)
    setOrgTree(iterate(props.organisations, null))
  }, [props.organisations])

  function iterate(orglist, parentId) {

    return orglist.filter(org => org.parentId === parentId).map(function (item, index) {
      let current = (currentId && item.ID == currentId) && true || false
      const children = iterate(orglist, item.ID);

      return (
        <li key={index}>
          {current ?
            <>
              <strong>{item.name}</strong> <span className="meta">({item.users})</span>
            </>
            :
            <>
              <Link to={`/clients/${item.clientId}/organisations/${item.ID}`}>{item.name}</Link> <span className="meta">({item.users})</span>
            </>
          }
          {children.length > 0 && <ul className="tree">{children}</ul>}
        </li>
      )
    })
  }

  return (
    <>
      {orgTree && <ul className="tree">{orgTree}</ul>}
    </>
  )
}